import React from 'react';
import { Link } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiYoutube, FiExternalLink } = FiIcons;

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'Tinman', path: '/tinman' },
    { name: 'The Playground', path: '/playground' },
    { name: 'Truth & Fairytales', path: '/fairytales' },
    { name: 'The Festivals', path: '/festivals' },
    { name: 'YouTube Shorts', path: '/shorts' },
    { name: 'In Print', path: '/print' },
    { name: 'The Team', path: '/team' },
    { name: 'Contact', path: '/contact' }
  ];

  return (
    <footer className="bg-black text-white pt-24 pb-12" role="contentinfo">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-16 mb-20">
          {/* Brand Section */}
          <div className="flex flex-col">
            <Link to="/" className="inline-block mb-6">
              <h3 className="text-3xl font-serif font-bold tracking-tight">SANDSTORM<span className="text-accent-orange">FLIX</span></h3>
            </Link>
            <p className="text-white/70 leading-relaxed mb-8 font-medium max-w-sm">
              Independent film production and creative direction by Kevin V. Tudor. Pushing the boundaries of storytelling through visual excellence.
            </p>
            <nav className="flex gap-4" aria-label="Social Media Links">
              <a 
                href="https://www.youtube.com/@sandstormflix" 
                target="_blank"
                rel="noopener noreferrer"
                aria-label="YouTube"
                className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center text-white hover:bg-accent-orange transition-all duration-500 hover:scale-110"
              >
                <SafeIcon icon={FiYoutube} className="w-5 h-5" />
              </a>
            </nav>
          </div>

          {/* Navigation Section */}
          <div className="lg:pl-12">
            <h4 className="text-[10px] font-bold text-accent-orange uppercase tracking-[0.3em] mb-8">Filmography</h4>
            <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-1 gap-x-8 gap-y-4">
              {navLinks.slice(0, 9).map((link) => (
                <li key={link.name}>
                  <Link 
                    to={link.path} 
                    className="text-white/60 hover:text-white transition-all duration-500 font-bold uppercase text-[10px] tracking-widest inline-block hover:translate-x-1"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal Section */}
          <div className="lg:pl-12">
            <h4 className="text-[10px] font-bold text-accent-orange uppercase tracking-[0.3em] mb-8">Resources</h4>
            <ul className="space-y-4">
              {[
                { name: 'Privacy Policy', path: '/privacy' },
                { name: 'Terms of Service', path: '/terms' },
                { name: 'Accessibility', path: '/accessibility' },
                { name: 'Contact Us', path: '/contact' }
              ].map((item) => (
                <li key={item.name}>
                  <Link 
                    to={item.path} 
                    className="text-white/60 hover:text-white transition-all duration-500 font-bold uppercase text-[10px] tracking-widest inline-block hover:translate-x-1"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
        
        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-white/40 text-[10px] font-bold uppercase tracking-[0.3em]">
            © {currentYear} Sandstorm Flix • All Rights Reserved
          </p>
          <a 
            href="https://mobilefirstpro.com" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-white/40 hover:text-accent-orange transition-colors text-[10px] font-bold uppercase tracking-[0.3em] flex items-center gap-2 group"
          >
            MADE BY <span className="text-white/60 group-hover:text-white transition-colors">MFP</span>
            <SafeIcon icon={FiExternalLink} className="w-3 h-3" />
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;